import Configuration from '../config';

export async function recordingRequest(fieldId, token, options = {}) {
  const response = await fetch(`${Configuration.apiEndPoint}/partners/fields/${fieldId}/hls-recording`, {
    ...options, cache: 'no-store',
    headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'application/json'}
  });
  const result = await response.json();
  if (!response.ok) throw new Error(typeof result.error === 'string' ? result.error : 'request_failed');
  return result;
}
